import { APIServices } from './axiosCommon';

export interface MonthlyReportRow {
  machineId: string;
  machineType: string;
  month: string;
  daysWithData: number;
  totesLoaded: number;
  kgsLoaded: number;
  kgsOffloaded: number;
  timeLoading: number;
}

export interface MonthlyReportResponse {
  from: string;
  to: string;
  rows: MonthlyReportRow[];
}

export const reportsApi = {
  monthly: (from: string, to: string) =>
    APIServices.get<{ success: boolean; data: MonthlyReportResponse }>('/reports/monthly', {
      params: { from, to },
    }),
  exportUrl: (from: string, to: string) =>
    `/api/reports/export.csv?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
};
